"use client";

import React from 'react';

const steps = [
  { 
    number: "01", 
    title: "Kontakt", 
    desc: "Zadzwoń, napisz lub wyślij zdjęcia obiektu przez formularz." 
  },
  { 
    number: "02", 
    title: "Bezpłatna konsultacja", 
    desc: "Umawiamy się na oględziny lub rozmawiamy zdalnie. Analizujemy potrzeby." 
  },
  { 
    number: "03", 
    title: "Wycena", 
    desc: "Przygotowujemy szczegółową ofertę z doborem sprzętu i harmonogramem." 
  },
  { 
    number: "04", 
    title: "Montaż", 
    desc: "Profesjonalna instalacja w ustalonym terminie. Testy i uruchomienie." 
  },
  { 
    number: "05", 
    title: "Szkolenie z obsługi", 
    desc: "Pokazujemy jak korzystać z systemu i aplikacji mobilnej. Przekazujemy dokumentację." 
  }
];

export default function HowItWorks() {
  const scrollToContact = () => {
    const el = document.getElementById('kontakt');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="jak-dzialamy" className="max-w-screen-2xl mx-auto px-8 py-20">
      <div className="max-w-3xl mx-auto text-center mb-14">
        <div className="text-blue-500 font-semibold tracking-[2px] text-sm mb-2">JAK DZIAŁAMY</div>
        <h2 className="text-4xl md:text-5xl font-semibold tracking-tighter mb-4">Jak wygląda współpraca?</h2>
        <p className="text-xl text-zinc-400">Prosty i przejrzysty proces — od pierwszego kontaktu do gotowego systemu.</p>
      </div>

      <div className="max-w-4xl mx-auto">
        <div className="grid md:grid-cols-5 gap-4">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="dark-card rounded-3xl p-6 h-full flex flex-col">
                <div className="text-blue-400 text-sm font-mono mb-3">{step.number}</div>
                <h3 className="font-semibold text-lg mb-2">{step.title}</h3>
                <p className="text-sm text-zinc-400 flex-1">{step.desc}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 -right-2 text-blue-500/40 text-xl">→</div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="text-center mt-12">
        <button 
          onClick={scrollToContact}
          className="px-8 py-3.5 bg-blue-600 hover:bg-blue-500 rounded-3xl font-semibold transition-colors"
        >
          Rozpocznij współpracę
        </button>
      </div>
    </section>
  );
}
